import { Router, UrlTree } from '@angular/router';
import { environment } from '@environments/environment';
import { inject } from '@angular/core';
import { isEmpty } from 'lodash';

export function oldUiWarningGuard(): UrlTree | true {
  const router = inject(Router);

  if (isEmpty(environment.legacyUiUrl)) {
    return router.parseUrl('/rs-number');
  }

  return true;
}
